import { Spacing } from 'UI'

export default theme => ({
  image: {
    borderRadius: 4,
    cursor: 'pointer',
    filter: 'brightness(0.5)'
  },
  selectedImageStyle: {
    border: `2px solid ${theme.neutral[400]}`,
    filter: 'brightness(1)'
  },
  view: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: 17,
    alignItems: 'center',
    backgroundColor: 'none',
    borderRadius: '0px 0px 4px 4px !important',
    padding: Spacing(0, 0, 4, 0)
  },
  cardStyle: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  bigImage: {
    objectFit: 'cover'
  },
  selectedProjectStyle: {
    filter: 'brightness(1)'
  },
  responsiveCard: {
    margin: () => Spacing(0, 2, 0, 0)
  },
  responsiveRow: {
    overflow: 'auto',
    flexWrap: 'nowrap !important',
    marginRight: '-15px !important'
  },
  imagesContainer: {
    position: 'relative',
    display: 'flex',
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center'
  },
  arrowsContainer: {
    display: 'flex',
    position: 'absolute',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '90%'
  },
  imagesWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 32
  },
  buttonStyle: {
    color: `${theme.secondary[0]} !important`,
    backgroundColor: `${theme.secondary[400]} !important`,
    cursor: 'pointer',
    borderRadius: '50% !important',
    height: '50px !important',
    width: '50px !important'
  },
  imageAndArrows: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  dots: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
    marginTop: 10
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: theme.neutral[0],
    cursor: 'pointer'
  },
  selectedDot: {
    backgroundColor: theme.secondary[0]
  }
})
